import React from "react";

export default function AWS_IAM() {
  return (
    <div>
      <h1>What is AWS IAM</h1>
      <p>
        Route: <code>/aws/iam</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
